import { TranslationsContext } from "@teliaee/telia-translate";
import React from "react";
import { AnalyticsTrigger, Button, Grid, GridColumn, Text, Heading, Separator } from "telia-front-react";
import { useAuth } from "../providers/AuthProvider.mjs";
import { useContactInfo } from "../providers/ContactInfoProvider.mjs";
import { useInvoices } from "../providers/InvoiceProvider.mjs";
import { useIsMobileHook } from "../util/ThemeHooks.mjs";
import { ContactInfoStatusValue } from "../interfaces/ContactInfoInterfaces.mjs";
import { canConfirmInformation, renderContactInfoFields } from "../util/ContactInfoUtil.mjs";
import InformationModalBase from "./InformationModalBase.mjs";
import SuccessModal from "./SuccessModal.mjs";
import AddressMismatchNotice from "./AddressMismatchNotice.mjs";
const ValidateInformationModal = () => {
  const { translate } = React.useContext(TranslationsContext);
  const { auth } = useAuth();
  const {
    invoiceSettingsState: { invoiceSettings }
  } = useInvoices();
  const {
    userInfoState: { userInfo },
    contactAddressState: { contactAddress },
    contactInfoStatusesState: { contactInfoStatuses },
    updateCheckContactInfosFlag,
    goToSelfServiceInfoUpdate,
    confirmContactInfos
  } = useContactInfo();
  const { isMobile } = useIsMobileHook();
  const [isModalOpen, setModalOpen] = React.useState(true);
  const [showSuccess, setShowSuccess] = React.useState(false);
  const getModalDescriptionText = () => {
    const { email, phone } = contactInfoStatuses;
    const isEmailUnvalidated = email.includes(ContactInfoStatusValue.UNVALIDATED);
    const isPhoneUnvalidated = phone.includes(ContactInfoStatusValue.UNVALIDATED);
    if (isEmailUnvalidated && isPhoneUnvalidated) {
      return translate("dataconfirm.validationcheck.emailAndPhone");
    }
    if (isEmailUnvalidated) {
      return translate("dataconfirm.validationcheck.email");
    }
    if (isPhoneUnvalidated) {
      return translate("dataconfirm.validationcheck.phone");
    }
    return translate("dataconfirm.validationcheck.checkyourinformation");
  };
  const getModalContent = () => {
    var _a;
    return /* @__PURE__ */ React.createElement(Text, null, /* @__PURE__ */ React.createElement(Heading, { className: "h2", id: "information-check-heading" }, translate("dataconfirm.validationCheck.".concat(canConfirmInformation(contactInfoStatuses) ? "confirm" : "validate", ".heading"))), /* @__PURE__ */ React.createElement("p", { className: "h4 text-bold" }, translate("common.dataconfirm.greeting", { name: (_a = auth == null ? void 0 : auth.person) == null ? void 0 : _a.firstName })), /* @__PURE__ */ React.createElement("p", null, getModalDescriptionText()), /* @__PURE__ */ React.createElement(Separator, { color: "invisible", spacing: "small" }), renderContactInfoFields(userInfo, contactInfoStatuses, contactAddress, translate, false), /* @__PURE__ */ React.createElement(AddressMismatchNotice, { contactInfoEmail: userInfo.email, contactInfoAddress: contactAddress, invoiceSettings }));
  };
  const getFooterButtons = () => {
    let confirmButton;
    let skipOrUpdateButton;
    if (canConfirmInformation(contactInfoStatuses)) {
      skipOrUpdateButton = /* @__PURE__ */ React.createElement(AnalyticsTrigger, { trigger: { id: "Button - update-data", callback: "onClick" } }, /* @__PURE__ */ React.createElement(
        Button,
        {
          text: translate("dataconfirm.validationCheck.updateData"),
          block: isMobile,
          iconRight: "#arrow-right",
          variant: "secondary",
          onClick: () => goToSelfServiceInfoUpdate(),
          id: "update-data"
        }
      ));
      confirmButton = /* @__PURE__ */ React.createElement(AnalyticsTrigger, { trigger: { id: "Button - confirm-data", callback: "onClick" } }, /* @__PURE__ */ React.createElement(
        Button,
        {
          text: translate("dataconfirm.validationCheck.confirmNow"),
          block: isMobile,
          type: "expressive",
          onClick: async () => {
            const confirmResult = await confirmContactInfos();
            if (confirmResult === "confirm_ok") {
              setShowSuccess(true);
            }
            setModalOpen(false);
          },
          id: "confirm-data"
        }
      ));
    } else {
      skipOrUpdateButton = /* @__PURE__ */ React.createElement(AnalyticsTrigger, { trigger: { id: "Button - change-later", callback: "onClick" } }, /* @__PURE__ */ React.createElement(
        Button,
        {
          text: translate("dataconfirm.validationCheck.changeLater"),
          iconRight: "#arrow-right",
          link: true,
          onClick: () => {
            updateCheckContactInfosFlag();
            setModalOpen(false);
          },
          id: "change-later"
        }
      ));
      confirmButton = /* @__PURE__ */ React.createElement(AnalyticsTrigger, { trigger: { id: "Button - validate-data", callback: "onClick" } }, /* @__PURE__ */ React.createElement(
        Button,
        {
          text: translate("dataconfirm.validationCheck.validateNow"),
          block: isMobile,
          iconRight: "#arrow-right",
          type: "expressive",
          onClick: () => goToSelfServiceInfoUpdate(),
          id: "validate-data"
        }
      ));
    }
    return /* @__PURE__ */ React.createElement(Grid, { align: ["middle-xs", "center-xs", "end-md"], className: "text-center" }, /* @__PURE__ */ React.createElement(GridColumn, { width: ["xs-12", "md"] }, skipOrUpdateButton), /* @__PURE__ */ React.createElement(GridColumn, { width: ["xs-12", "md"] }, confirmButton));
  };
  if (showSuccess) {
    return /* @__PURE__ */ React.createElement(SuccessModal, { onCloseCallback: () => setShowSuccess(false) });
  }
  return /* @__PURE__ */ React.createElement(
    InformationModalBase,
    {
      isModalOpen,
      analyticsId: "contact-info-validation-cancel",
      modalContent: getModalContent(),
      modalFooter: getFooterButtons(),
      modalCloseCallback: () => {
        updateCheckContactInfosFlag();
        setModalOpen(false);
      }
    }
  );
};
export {
  ValidateInformationModal as default
};
